module.exports = __webpack_public_path__ + "static/placeholder-78872876a81e8abd2f371a915c32e053.jpg";